import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class NvProjectStaffApi extends NewviewOaBaseApi { 
    
    public get ControllerName(): any {
        return 'nv-project-staff'
    }
}